import Layout from '../../layout/Layout';
import { Row, Col, Spinner, Button } from 'reactstrap';
import styles from './CategoriesPage.module.scss';
import { useState, useEffect, useRef } from 'react';
import { getRequest } from '../../global/utils/apiCall';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import SEO from '../../global/Components/SEO/SEO';


const CATEGORIES_URL = 'api/v1/categories';

export default function CategoriesPage() {
    const toast = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [categories, setCategories] = useState([]);
    const [back, setBack] = useState([]);
    
    // const [parentId, setParentId ] = useState(searchParams.get('parent_id') || 0);
    
    const [isLoading, setIsLoading] = useState(false);
    
    const navigate = useNavigate();

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleCategoryClick = async (catData = null) => {
        
        if (catData != null && !catData.has_child) {
            navigate(`/product-list/${catData.id}/${catData.title.replace(/\s+/g, '-')}`,{state:{replace:false}});
            return
        }
        if(catData != null){
            searchParams.set('parent_id', catData.id);
            setSearchParams(searchParams);
            setBack([...back, catData.pid]);
        }
    }
    
    const callCategories = async () => {
        setIsLoading(true);

        try{
            const response = await getRequest(CATEGORIES_URL,{
                params: {
                    parent_id: searchParams.get('parent_id') ,
                    limit:50,
                    is_feature:''
                }
            });
            setCategories(response.data.data);
            setIsLoading(false);

        }
        catch (error){
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message)
            } 
            setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }
    }

    const handleBackButton = async () => {
        searchParams.set('parent_id', back[back.length -1 ]);
        setSearchParams(searchParams); 
        setBack(back.slice(0 , back.length -1));
    }
    
    useEffect(() => {
        handleCategoryClick();   
    },[]);

    useEffect(() => {
        callCategories();
    },[searchParams]);

  return (
    <Layout>
        <SEO title={'Categories'} />
        <Toast ref={toast} position="top-center" />

        <div className="container-xxl">
            <Row className={`pt-5 pb-3`}>
                <Col md={12}>
                    {
                        back.length > 0 &&
                            <Button 
                                className={`text-decoration-none mb-3`}
                                onClick={() => handleBackButton()}
                            >
                                <i className="bi bi-arrow-left"></i>
                            </Button>
                    }
                </Col>
                <Col md={12}>
                    <div className={`${styles.wrapper} d-flex flex-row flex-wrap `}>
                        {
                            isLoading ? (
                                <>
                                     <Spinner color='primary' className='mx-auto'>
                                        Loading...
                                    </Spinner>
                                </>
                            ) : (
                                categories &&
                                    categories.map((catData) => (
                                        <a 
                                            key={catData.id}
                                            id={catData.id} 
                                            className={`${styles.categoryItem} mx-2 text-decoration-none fw-bold`}
                                            onClick={() => handleCategoryClick(catData)}
                                        >
                                            {
                                                // <Category listData={catData} />
                                                <category-item id={catData.id}>
                                                    <img className={`${styles.coverImage} img-fluid`} src={`${!catData.image ? 'images.png' : `${process.env.REACT_APP_API_URL}${catData.image}`}`} />
                                                    <div  className={` text-center p-3`}>
                                                        <div className={`py-1 ${styles.title}`}>{catData.title}</div>
                                                    </div>
                                                </category-item>
                                            }
                                        </a>

                            ))
                            )
                        }
                    </div>
                </Col>
            </Row>
        </div>
    </Layout>
  )
}
